import { z } from "zod";
/**
 * ConsentScope: code-driven consent. Every bit of data ingress or egress
 * is guarded by a scope string that must be granted explicitly and can be
 * revoked at any time. See docs/HealthOS_Design_Doc.md section 7.
 */
export const ConsentScopeSchema = z.enum([
    "read:signals:movement",
    "read:signals:sleep",
    "read:signals:heart",
    "read:signals:glucose",
    "read:signals:weight",
    "read:signals:bp",
    "read:signals:medication",
    "read:signals:mood",
    "read:signals:stress",
    "read:signals:nutrition",
    "read:signals:calendar",
    "read:ehr:summary",
    "read:ehr:labs",
    "write:delivery:companion",
    "write:delivery:email",
    "write:delivery:push",
    "write:delivery:sms",
    "write:delivery:partner-embed",
    "llm:plan:tam",
    "llm:process:tam",
    "llm:heartbeat:haiku",
    "share:partner:pharma-portal",
    "share:partner:payer-portal",
]);
export const ConsentGrantSchema = z.object({
    userId: z.string().min(1),
    scope: ConsentScopeSchema,
    grantedAt: z.string().datetime(),
    revokedAt: z.string().datetime().optional(),
    purpose: z.string().max(500),
    retentionDays: z.number().int().min(0).max(3650),
    source: z.enum(["onboarding", "settings", "partner-portal", "legal-admin"]),
    partnerId: z.string().optional(),
});
export function isConsentActive(grant, at = new Date()) {
    const granted = new Date(grant.grantedAt).getTime() <= at.getTime();
    const notRevoked = !grant.revokedAt || new Date(grant.revokedAt).getTime() > at.getTime();
    return granted && notRevoked;
}
//# sourceMappingURL=consent.js.map